export default "__VITE_ASSET__DUwoByGU__"